<template>
    <div class="layer">
        <div class="wrap">
            <Header></Header>
            <div class="content_layer">
                <div class="content">
                    <div id="board_layer">
                        <!-- <Menu></Menu> -->
                        <div class="board_search_v1 board_search_wrap">
                            <div>
                                <div class="sch_box">
                                    <select name="" id="" class="select" v-model.number="filter.searchType">
                                        <option value="0">이름</option>
                                        <option value="1">팀</option>
                                        <option value="2">직책</option>
                                    </select>
                                    <div class="sch_input_box" v-if="filter.searchType == 0">
                                        <input
                                            type="text"
                                            placeholder="검색어를 입력하세요."
                                            v-model="filter.keyword"
                                            @keydown.enter="getUserList"
                                        />
                                    </div>
                                    <div class="sch_input_box" v-else>
                                        <select class="filter_select" v-model="filter.selectItem">
                                            <template v-if="filter.searchType == 1">
                                                <option v-for="item in state.deptList" :value="item.idx">
                                                    {{ item.name }}
                                                </option>
                                            </template>
                                            <template v-if="filter.searchType == 2">
                                                <option v-for="item in state.positionList" :value="item.idx">
                                                    {{ item.name }}
                                                </option>
                                            </template>
                                        </select>
                                    </div>
                                    <div class="sch_btns">
                                        <button type="button" class="sch_btn" @click="getUserList">검색하기</button>
                                        <button type="button" class="sch_re_btn" @click="resetSearch">
                                            <img src="@/assets/board/re_btn.png" alt="" />
                                            초기화
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="board_top">
                            <div class="board_top_btns">
                                <button type="button" class="board_btn board_ico_btn" @click="excelDownLoad">
                                    <span>엑셀다운로드</span>
                                    <img src="@/assets/board/excel_ico.png" alt="" />
                                </button>
                            </div>
                            <div class="">
                                <button type="button" class="board_btn" @click="openmodal(1)">추가</button>
                            </div>
                        </div>
                        <div class="board_list">
                            <table class="board_table">
                                <colgroup>
                                    <col width="4%" />
                                    <col width="4%" />
                                    <col width="10%" />
                                    <col width="10%" />
                                    <col width="10%" />
                                    <col width="10%" />
                                    <col width="14%" />
                                    <col width="14%" />
                                    <col width="12%" />
                                    <col width="6%" />
                                    <col width="6%" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>
                                            <label class="chk">
                                                <input type="checkbox" v-model="state.checkList[0]" @input="checkedList(0)" />
                                                <span></span>
                                            </label>
                                        </th>
                                        <th>순번</th>
                                        <th>아이디</th>
                                        <th>이름</th>
                                        <th>팀</th>
                                        <th>직책</th>
                                        <th>등록일시</th>
                                        <th>최종로그인</th>
                                        <th>구분</th>
                                        <th>승인여부</th>
                                        <th>X 계정</th>
                                    </tr>
                                </thead>
                                <tbody v-if="!state.isLoading">
                                    <tr v-for="(item, idx) in user.list">
                                        <td>
                                            <label class="chk">
                                                <input type="checkbox" v-model="state.checkList[idx + 1]" @input="checkedList(idx + 1)" />
                                                <span></span>
                                            </label>
                                        </td>
                                        <td>
                                            {{
                                                state.currentPage === 1
                                                    ? numberFormat(idx + 1)
                                                    : numberFormat(state.perPage * (state.currentPage - 1) + idx + 1)
                                            }}
                                        </td>
                                        <td>{{ item.id }}</td>
                                        <td>{{ item.name }}</td>
                                        <td>{{ item.deptVO?.name }}</td>
                                        <td>{{ item.positionVO?.name }}</td>
                                        <td>
                                            {{ formatDate(item.createDate) }}
                                        </td>
                                        <td>
                                            {{ item.loginDate ? formatDate(item.loginDate) : "" }}
                                        </td>
                                        <td>
                                            <div class="board_btns">
                                                <button type="button" class="blue_btn" @click="openmodal(2, item.idx)">상세</button>
                                                <button type="button" class="gray_btn" @click="deleteUser(idx)">삭제</button>
                                            </div>
                                        </td>
                                        <td>
                                            <span>
                                                <img
                                                    :src="
                                                        item.state === 1
                                                            ? require('@/assets/board/approve.png')
                                                            : require('@/assets/board/no_approve.png')
                                                    "
                                                    alt=""
                                                />
                                            </span>
                                        </td>
                                        <td>
                                            <span>
                                                <img
                                                    :src="
                                                        item.twitterId !== null && item.twitterId !== ''
                                                            ? require('@/assets/board/approve.png')
                                                            : require('@/assets/board/no_approve.png')
                                                    "
                                                    alt=""
                                                />
                                            </span>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-if="user.list.length === 0 && !state.isLoading">
                                    <tr>
                                        <td colspan="10">
                                            <NoResult></NoResult>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-if="state.isLoading">
                                    <tr>
                                        <td colspan="10">
                                            <Spinner></Spinner>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <PageBtn
                            v-if="user.list.length !== 0 && !state.isLoading"
                            :currentPage="state.currentPage"
                            :totalLength="state.totalLength"
                            :perPage="state.perPage"
                            @onPaging="handlePageChange"
                        ></PageBtn>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <UserModal :userInfo="user.info" :show="modal.isUserModal" @close="modalClose" :btnTitle="modal.btnTitle"></UserModal>
</template>
<script lang="ts" config>
    import {
        Header,
        Menu,
        apiService,
        onMounted,
        reactive,
        formatDate,
        PageBtn,
        globalStore,
        UserModal,
        NoResult,
        Spinner,
        numberFormat,
    } from "@/BaseComponent";
    export default {
        props: {},
        components: {
            Header,
            Menu,
            PageBtn,
            UserModal,
            NoResult,
            Spinner,
        },
        setup() {
            const global = globalStore();
            const state = reactive({
                isLoading: true as boolean,
                currentPage: 1 as number,
                totalLength: 0 as number,
                perPage: 100 as number,
                deptList: [] as Array<any>,
                positionList: [] as Array<any>,
                checkAll: false as boolean,
                checkList: [] as Array<boolean>,
            });

            const modal = reactive({
                isUserModal: false as boolean,
                btnTitle: "" as string,
                actionCode: 0 as number,
            });

            const user = reactive({
                info: null as object | null,
                colWidth: ["4%", "4%", "10%", "10%", "10%", "10%", "14%", "14%", "12%", "10%"] as Array<string>,
                list: [] as Array<any>,
                search: "" as string | null,
                size: 8 as number,
            });

            const filter = reactive({
                position: 0 as number,
                dept: 0 as number,
                searchType: 0 as number,
                selectItem: 1 as number,
                keyword: "" as string,
            });

            onMounted(() => {
                if (!global.dept) getDeptList();
                if (!global.position) getPositionList();
                global.setSelectMenu(98);
                getUserList();
                state.deptList = global.dept;
                state.positionList = global.position;
            });

            const getDeptList = async () => {
                const res = await apiService.base.getDeptList();
                if (res.returnCode === 0) {
                    state.deptList = res.list;
                }
            };

            const getPositionList = async () => {
                const res = await apiService.base.getPositionList();
                if (res.returnCode === 0) {
                    state.positionList = res.list;
                }
            };

            const getUserList = async () => {
                state.isLoading = true;
                switch (filter.searchType) {
                    case 0:
                        filter.dept = 0;
                        filter.position = 0;
                        break;
                    case 1:
                        filter.keyword = "";
                        filter.dept = filter.selectItem;
                        filter.position = 0;
                        break;
                    case 2:
                        filter.keyword = "";
                        filter.dept = 0;
                        filter.position = filter.selectItem;
                        break;

                    default:
                        break;
                }
                const res = await apiService.membar.getUserList(
                    state.currentPage,
                    state.perPage,
                    filter.keyword,
                    filter.dept,
                    filter.position,
                );
                if (res.returnCode === 0) {
                    for (let i = 0; i < res.list.data.length + 1; i++) {
                        state.checkList[i] = false;
                    }
                    user.list = res.list.data;
                    state.totalLength = res.list.recordsTotal;
                } else {
                    user.list = [];
                }
                state.isLoading = false;
            };

            const getUserDetail = async (idx: number) => {
                const res = await apiService.membar.getUserDetail(idx);
                if (res.returnCode === 0) {
                    user.info = res.data;
                    modal.btnTitle = "수정하기";
                    modal.isUserModal = true;
                }
            };

            const removeUser = async (idx: number) => {
                const res = await apiService.membar.removeUser(idx);
                if (res.returnCode === 0) {
                    alert("삭제 완료되었습니다.");
                    getUserList();
                }
            };

            const addUser = async (data: object) => {
                const res = await apiService.membar.addUser(data);
                if (res.returnCode === 0) {
                    alert("사용자 추가 완료되었습니다.");
                    getUserList();
                } else {
                    alert(res.description);
                    console.error(res.description);
                }
            };

            const modifyUse = async (data: object) => {
                const res = await apiService.membar.modifyAdmin(data);
                if (res.returnCode === 0) {
                    alert("사용자 수정이 완료되었습니다.");
                    getUserList();
                }
            };

            const handlePageChange = (page: number) => {
                state.currentPage = page;
                getUserList();
            };

            const openmodal = async (action: number, itemIdx = 0) => {
                switch (action) {
                    case 1:
                        modal.actionCode = 1;
                        user.info = null;
                        modal.btnTitle = "추가하기";
                        modal.isUserModal = true;
                        break;
                    case 2:
                        modal.actionCode = 2;
                        await getUserDetail(itemIdx);
                        break;
                }
            };

            const deleteUser = (idx: number) => {
                if (user.list[idx].clfCd === 99) {
                    alert("관리자는 삭제가 불가능합니다");
                } else {
                    if (confirm("사용자를 삭제하시겠습니까?")) {
                        removeUser(user.list[idx].idx);
                    }
                }
            };

            const modalClose = (res: boolean, data: any) => {
                modal.isUserModal = false;
                if (res) {
                    switch (modal.actionCode) {
                        case 1:
                            addUser(data);
                            break;
                        case 2:
                            modifyUse(data);
                            break;
                    }
                }
            };

            const resetSearch = () => {
                state.perPage = 10;
                state.currentPage = 1;
                filter.dept = 0;
                filter.position = 0;
                filter.searchType = 0;
                filter.selectItem = 1;
                filter.keyword = "";
                getUserList();
            };

            const checkedList = (idx: number) => {
                if (idx === 0) {
                    const isAllChecked = state.checkList[0];
                    for (let i = 1; i < user.list.length + 1; i++) {
                        state.checkList[i] = !isAllChecked;
                    }
                } else {
                    state.checkList[idx] = !state.checkList[idx];
                }
                state.checkList[0] = state.checkList.slice(1).every((item) => item);
            };

            const excelDownLoad = async () => {
                let checkedIdx = "" as any;
                if (state.checkList.some((value) => value === true)) {
                    checkedIdx = user.list.filter((item: any, index: number) => state.checkList[index + 1]).map((item: any) => item.idx);
                }
                const res: any = await apiService.excel.memberList(
                    state.currentPage,
                    state.perPage,
                    filter.keyword === "" ? null : filter.keyword,
                    filter.searchType === 1 ? filter.selectItem : 0,
                    filter.searchType === 2 ? filter.selectItem : 0,
                    checkedIdx ? checkedIdx.join(",") : null,
                );
                if (res.status === 200) {
                    const blob = res.data;
                    const fileUrl = URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = fileUrl;
                    link.download = "계정관리_리스트.xlsx";
                    link.click();
                    URL.revokeObjectURL(fileUrl);
                    return alert("다운로드 완료 되었습니다.");
                }
            };

            return {
                state,
                user,
                modal,
                filter,
                openmodal,
                deleteUser,
                modalClose,
                formatDate,
                getUserList,
                handlePageChange,
                resetSearch,
                checkedList,
                excelDownLoad,
                numberFormat,
            };
        },
    };
</script>
<style scoped>
    #board_layer .board_btn {
        cursor: pointer;
    }

    .sch_input_box > .filter_select {
        border-radius: unset;
        border: none;
        width: 100% !important;
    }
</style>
